import React, { useEffect, useState } from "react"
import { useAuth } from "../../context/AuthContext"
import { supabase } from "../../lib/supabaseClient"
import { useNavigate } from "react-router-dom"

const RacketSettingsPage: React.FC = () => {
  const { profile, refreshProfile } = useAuth()
  const navigate = useNavigate()

  const [brand, setBrand] = useState("")
  const [description, setDescription] = useState("")
  const [tensionV, setTensionV] = useState("")
  const [tensionH, setTensionH] = useState("")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!profile) return

    setBrand(profile.default_racket_brand || "")
    setDescription(profile.default_racket_description || "")
    setTensionV(profile.default_tension_vertical?.toString() || "")
    setTensionH(profile.default_tension_horizontal?.toString() || "")
  }, [profile])

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    const { error } = await supabase.from("profiles")
      .update({
        default_racket_brand: brand || null,
        default_racket_description: description || null,
        default_tension_vertical: tensionV ? Number(tensionV) : null,
        default_tension_horizontal: tensionH ? Number(tensionH) : null,
      })
      .eq("id", profile?.id)

    setLoading(false)

    if (error) {
      alert("Erreur lors de la mise à jour.")
      console.error(error)
      return
    }

    await refreshProfile()
    navigate("/account")
  }

  return (
    <div className="card" style={{ maxWidth: 600, margin: "2rem auto" }}>
      <h1 className="card-title">Raquette par défaut</h1>

      <p style={{ marginBottom: "1rem", color: "#9ca3af" }}>
        Ces informations seront automatiquement pré-remplies lors d’une commande.
      </p>

      <form onSubmit={handleSave}>

        <label className="label">Marque / Modèle</label>
        <input
          className="input"
          value={brand}
          onChange={e => setBrand(e.target.value)}
        />

        <label className="label" style={{ marginTop: "1rem" }}>Description</label>
        <input
          className="input"
          value={description}
          onChange={e => setDescription(e.target.value)}
        />

        <label className="label" style={{ marginTop: "1rem" }}>Tension verticale (kg)</label>
        <input
          className="input"
          type="number"
          value={tensionV}
          onChange={e => setTensionV(e.target.value)}
        />

        <label className="label" style={{ marginTop: "1rem" }}>Tension horizontale (kg)</label>
        <input
          className="input"
          type="number"
          value={tensionH}
          onChange={e => setTensionH(e.target.value)}
        />

        <button
          className="btn btn-primary"
          type="submit"
          style={{ marginTop: "1.5rem" }}
        >
          {loading ? "Enregistrement…" : "Enregistrer"}
        </button>
      </form>
    </div>
  )
}

export default RacketSettingsPage
